import TokenAuthenticationHandler from "@/services/authentication_services/handlers/TokenAuthenticationHandler";
import AxiosAuthenticationHandler from "@/services/authentication_services/handlers/AxiosAuthenticationHandler";
import WebSocketAuthenticationHandler from "@/services/authentication_services/handlers/WebSocketAuthenticationHandler";
import ActingUserAuthenticationHandler from "@/services/authentication_services/handlers/ActingUserAuthenticationHandler";
import StoreAuthenticationHandler from "@/services/authentication_services/handlers/StoreAuthenticationHandler";


var BASE_AUTHENTICATION_HANDLERS = [
    TokenAuthenticationHandler,
    AxiosAuthenticationHandler,
    WebSocketAuthenticationHandler,
    ActingUserAuthenticationHandler,
    StoreAuthenticationHandler
];

export default BASE_AUTHENTICATION_HANDLERS;
